<!--
 * @Author: your name
 * @Date: 2020-09-29 13:33:37
 * @LastEditTime: 2020-10-22 14:43:28
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\pages\login.vue
-->
<template>
<div class="login">
    <!-- <div class="login_box">
        <div class="imgbox">
            <img src="/static/images/denglu_photo.png" alt="" srcset="" />
        </div>
        <div>
            <account v-if="activeName=='account'" @back="back"></account>
            <wxlogin v-if="activeName=='wx'" @back="back"></wxlogin>
            <phone v-if="activeName=='phone'" @back="back"></phone>
        </div>
    </div> -->
</div>
</template>

<script>
import account from "@/components/login/account"
import wxlogin from "@/components/login/wxlogin"
import phone from "@/components/login/phone"
export default {
    data:function() {
        return {
            activeName: "account"
        };
    },
    components: {
        account,
        wxlogin,
        phone
    },
    methods: {
        gorouter: function () {
            // var date = new Date();
            // var expireDays = 1; //将date设置为10天以后的时间
            // date.setTime(date.getTime() + expireDays * 24 * 3600 * 1000); //将userId和userName两个cookie设置为10天后过期
            // document.cookie =
            // "userId=828; userName=hulk; expire=" + date.toGMTString();

            this.$router.replace({
                path: "/", //this.$route.params.path,
                params: this.$route.params.params,
                query: this.$route.params.query
            });
        },
        back: function (val) {
            this.activeName = val
        }
    },
    mounted() {
        // 如果当前页面不在登录状态，则执行登录，更新用户信息
        
           this.oauthapi.oauthLogin('').then(res => {
               if (res.code == 0) {
                   //保存Token
                   localStorage.setItem("token", res.data.token);
                   // 更新用户信息
                    this.oauthapi.userInfo().then(res => {
                        localStorage.setItem('userinfo', JSON.stringify(res.data))
                        this.userinfo = res.data;
                        //登录成功之后直接跳转到写作台页面
                        this.$router.replace({
                            path: "/page/writing", //this.$route.params.path,
                            params: this.$route.params.params,
                            query: this.$route.params.query
                        });
                    })
               }
           })
    }
};
</script> 

<style lang="scss" scoped>
.login {
    .login_box {
        display: flex;
        flex-wrap: nowrap;
        width: $mWidth;
        margin: 0 auto;
        height: 720px;
        margin-top: calc(50vh - 360px);
        box-shadow: 0px 0px 20px 10px rgba(86, 118, 189, 0.2);
        border-radius: 20px;

        .imgbox {
            width: 620px;
            height: 720px;

            img {
                width: 620px;
                height: 720px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue